import { Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import BottomNavigation from '../mobile/BottomNavigation';
import Sidebar from '../desktop/Sidebar';
import EmployeeLinkModal from '../EmployeeLinkModal';
import UserAvisos from '../UserAvisos';
import { LogOut, User } from 'lucide-react';
import { useHeader } from '../../context/HeaderContext';

import AvatarCom from '../Avatar';

const UserLayout = () => {
    const { user, logout, needsEmployeeLink } = useAuth();
    const { headerExtra } = useHeader();

    // Verificar si el usuario necesita vincular su cuenta
    const isUnlinked = needsEmployeeLink();

    // Nick logic: prioritizes conductor name (shorter/nick-like) over user name
    const displayName = user?.conductorNombre?.split(' ')[0] || user?.nombre || 'Usuario';

    return (
        <div className="min-h-screen text-white flex relative overflow-x-hidden" style={{ background: 'var(--bg-primary)', color: 'var(--text-primary)' }}>
            {/* Employee Link Modal ... */}
            {isUnlinked && (
                <EmployeeLinkModal
                    isOpen={true}
                    onClose={() => logout()}
                />
            )}

            {/* Desktop Sidebar */}
            {!isUnlinked && <Sidebar />}

            {/* Main Content Area */}
            <div className="flex-1 flex flex-col min-h-screen pb-20 md:pb-0">
                {/* Mobile Header - FIXED */}
                <header className="md:hidden fixed top-0 left-0 right-0 z-50 backdrop-blur-3xl border-b" style={{ borderColor: 'var(--border-color)', background: 'var(--header-bg)' }}>
                    <div className="flex items-center justify-between px-4 py-2">
                        <div className="flex items-center gap-2">
                            <div className="w-9 h-9 rounded-full bg-gradient-to-br from-cyan-500 to-blue-600 flex items-center justify-center shadow-lg shadow-cyan-500/20 overflow-hidden">
                                <AvatarCom 
                                    src={user?.picture} 
                                    name={user?.conductorNombre || user?.nombre}
                                    alt="Avatar" 
                                />
                            </div>
                            <div className="flex flex-col">
                                <h1 className="text-sm font-black tracking-tight" style={{ color: 'var(--text-primary)' }}>
                                    {displayName}
                                </h1>
                                <p className="text-[9px] font-bold uppercase tracking-widest -mt-0.5" style={{ color: 'var(--accent-label)' }}>
                                    {isUnlinked ? 'Sin vincular' : 'conductor'}
                                </p>
                            </div>
                        </div>

                        <div className="flex items-center gap-1.5">
                            {/* Dashboard Extra Info Portal */}
                            {!isUnlinked && headerExtra}

                            <div className="w-px h-4 bg-[var(--glass-border)] mx-1" />

                            {!isUnlinked && <UserAvisos variant="badge" />}
                            <button onClick={logout} className="p-2 text-[var(--text-muted)] hover:text-[var(--text-primary)] transition-colors">
                                <LogOut className="w-5 h-5" />
                            </button>
                        </div>
                    </div>
                </header>

                {/* Desktop Header - hidden for unlinked users */}
                {!isUnlinked && (
                    <header className="hidden md:flex items-center justify-between px-6 py-4 border-b" style={{ borderColor: 'var(--border-color)' }}>
                        <div>
                            <h1 className="text-xl font-bold" style={{ color: 'var(--text-primary)' }}>Mi Calendario</h1>
                            <p className="text-sm" style={{ color: 'var(--text-muted)' }}>Gestiona tu jornada laboral</p>
                        </div>
                        <div className="flex items-center gap-4">
                            <span className="text-sm" style={{ color: 'var(--text-secondary)' }}>{user?.email}</span>
                        </div>
                    </header>
                )}

                {/* Main Content - Full viewport height on mobile for calendar */}
                <main className="flex-1 px-0 md:px-6 md:py-6 overflow-x-hidden overflow-y-visible md:overflow-y-auto pt-[var(--mobile-header-height)] md:pt-0 mobile-main-content">
                    <Outlet />
                </main>
            </div>

            {/* Mobile Navigation - hidden on desktop, HIDDEN for unlinked users */}
            {!isUnlinked && (
                <div className="md:hidden">
                    <BottomNavigation />
                </div>
            )}
        </div>
    );
};

export default UserLayout;
